export { Typography as default } from "./Typography-styles";
